import appStore from 'store';
import api from './api';
import { PAGINATION } from 'common/config';

const store = {
  namespaced: true,
  state: {
    currencyIntroductionList: [],
    introductionDetail: {
      description: {},
      teamDescription: {}
    },
    detailDialogVisible: false,
    pagination: PAGINATION,
    totalCount: 0
  },
  getters: {},
  mutations: {
    setCurrencyIntroductionList(state, payload) {
      state.currencyIntroductionList = payload.list.slice();
      state.totalCount = payload.totalCount;
    },
    toggleDetailDialogVisible(state, payload) {
      state.detailDialogVisible = payload;
    },
    setIntroductionDetail(state, payload) {
      state.introductionDetail = payload;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    }
  },
  actions: {
    list({ commit }, { query, page, size }) {
      api
        .getCurrencyIntroductionList({ query, page, size })
        .then(({ data }) => {
          commit('setPagination', { page, size });
          commit('setCurrencyIntroductionList', data);
        });
    },
    detail({ commit }, id) {
      return api.getCurrencyIntroductionDetail(id).then(({ data }) => {
        commit('setIntroductionDetail', {
          ...data,
          description: data.description ? JSON.parse(data.description) : {},
          teamDescription: data.teamDescription
            ? JSON.parse(data.teamDescription)
            : {}
        });
      });
    },
    create(context, introduction) {
      return api.createCurrencyIntroduction(introduction);
    },
    update(context, introduction) {
      return api.updateCurrencyIntroduction(introduction);
    },
    remove(context, id) {
      return api.removeCurrencyIntroduction(id);
    }
  }
};

appStore.registerModule('currencyIntroductionSetting', store);
